import { render } from "./Template.vue?vue&type=template&id=89bf7de8&scoped=true&ts=true"
import script from "./Template.vue?vue&type=script&lang=ts"
export * from "./Template.vue?vue&type=script&lang=ts"

import "./Template.vue?vue&type=style&index=0&id=89bf7de8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-89bf7de8"]])

export default __exports__